// extracted by mini-css-extract-plugin
export default {"myModal":"modal_myModal__7IN+M","myModalContent":"modal_myModalContent__IhlwP","active":"modal_active__LupbI"};